<template>
    <v-container>
        <div class="container">
            <h3>Upload Signature</h3>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
                <div class="row form-group" style="min-height: ">
                  <div class="col-md-2">
                    <v-avatar
                      size="100px"
                      v-ripple
                      v-if="!url"
                      class="grey lighten-3 mb-3"
                    >
                    </v-avatar>
                    <v-avatar size="100px" v-ripple v-else class="mb-3">
                      <v-img :src="url"></v-img>
                    </v-avatar>
                    <!-- <v-img :src="'http://localhost:8000/storage/uploads/profile_photo/v73hxqcvmjU0kcj9y5GcriE9BlcANiM8bah1mpB4.jpg' "></v-img> -->
                  </div>
                  <div class="col" style="align-content: bottom; display: flex">
                    <v-file-input
                      @change="Preview_image"
                      v-model="formData.foto"
                      placeholder="Upload Your Signature (上传签名)"
                      style="max-height: 100px"
                      class="fileInput"
                      id="file"
                      ref="file"
                    >
                    </v-file-input>
                  </div>
                </div>
                <!-- <v-file-input
                  accept="image/*"
                  label="File input"
                ></v-file-input> -->
                <v-btn
                  :disabled="!valid"
                  color="success"
                  class="mr-4"
                  @click="uploadSignature"
                >
                  Submit
                </v-btn>

                <v-btn
                  color="error"
                  class="mr-4"
                  @click="onClose"
                >
                  Cancel
                </v-btn>
            
            </v-form>
        </div>
    </v-container>
</template>

<script>
import axios from '@/axios'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
  export default {
    data: () => ({
      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      form:{},
      show1:false,
      show2:false,
      formData:{}
    }),

    methods: {
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onClose(){
          this.form = {}
          this.$emit('onCloseDialog');
      },
      uploadSignature(){
          console.log(this.formData.foto)
          let sendData = new FormData();

          sendData.append('foto', this.formData.foto);
          sendData.append('id',this.idDatatable);

          console.log(sendData);
          axios({
                    method: 'post',
                    url: 'uploadsignature',
                    data: sendData,
                    headers: {
                      'Authorization': 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                     Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:'Tanda Tangan Berhasil di Upload!'
                            });
                    //this.printProfile(response.data.id,this.formData.na
                    this.form={}
                    this.onClose();
                    // this.$emit('closeDialog');
                    // console.log(JSON.stringify(response));
                    // this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
      },
      Preview_image(event) {
        this.url= URL.createObjectURL(this.formData.foto);
      }
    },
    props: {
        idDatatable: String
    }
  }
</script>